import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { t as n } from "../internals/to-string.js";
var o = t("".charAt),
  e = t("".charCodeAt),
  a = t(/./.exec),
  s = t(1..toString),
  i = t("".toUpperCase),
  f = /[\w*+\-./@]/,
  c = function c(r, t) {
    for (var n = s(r, 16); n.length < t;) n = "0" + n;
    return n;
  };
r({
  global: !0
}, {
  escape: function escape(r) {
    for (var t, s, u = n(r), l = "", p = u.length, m = 0; m < p;) a(f, t = o(u, m++)) ? l += t : (s = e(t, 0)) < 256 ? l += "%" + c(s, 2) : l += "%u" + i(c(s, 4));
    return l;
  }
});